// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gFDq","left":"styles_left__3j4w3"};